export default "__VITE_ASSET__emyzImsc__"